/* eslint-disable */
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
// import Typography from "@material-ui/core/Typography";
import {
  TableBody,
  TableCell,
  // TableRow,
  TableHead,
  // IconButton,
  Button
} from "@material-ui/core";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";

import Grid from "@saleor/components/Grid";
import { sectionNames } from "@saleor/intl";
// import { maybe, renderCollection } from "@saleor/misc";
import { maybe } from "@saleor/misc";
import { ProductActivationSetting_productActivationSetting } from "@saleor/productActivationSetting/types/ProductActivationSetting";

import React from "react";
// import Skeleton from "@saleor/components/Skeleton";
import ResponsiveTable from "@saleor/components/ResponsiveTable";

import TextField from "@material-ui/core/TextField";
import FormSpacer from "@saleor/components/FormSpacer";

import SaveButtonBar from "@saleor/components/SaveButtonBar";
import S3TextField from "@saleor/components/S3TextField";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import { FormattedMessage, useIntl } from "react-intl";
import CardSpacer from "@saleor/components/CardSpacer";
import { useState } from "react";
import MultimediaEditor from "@saleor/components/MultimediaEditor";

export interface ProductActivationSettingDetailsProps {
  setting: ProductActivationSetting_productActivationSetting | null;
  disabled: boolean;
  onSubmit: (data: SettingFormData) => void;
  onBack: () => void;
  saveButtonBarState: ConfirmButtonTransitionState;
  onRowClick: (id: string) => () => void;
  onAddVoucher: (type: string) => () => void;
  defaultCreate: () => void;
}
export interface SettingFormData {
  activationPcTitle: string;
  activationPcContent: string;
  activationPcSuccessedTitle: string;
  activationPcSuccessedContent: string;
  activationMbTitle: string;
  activationMbContent: string;
  activationMbSuccessedTitle: string;
  activationMbSuccessedContent: string;
  serialNumberPcContent: string;
  serialNumberMbContent: string;

  registerCouponPcBg: string;
  completeCouponPcBg: string;
  activationCouponPcBg: string;
  registerCouponMbBg: string;
  completeCouponMbBg: string;
  activationCouponMbBg: string;

  // registerCouponCode: string;
  // completeCouponCode: string;
  // activationCouponCode: string;
}
const ProductActivationSettingDetails: React.FC<ProductActivationSettingDetailsProps> = ({
  setting,
  disabled,
  onSubmit,
  onBack,
  saveButtonBarState,
  // onRowClick,
  onAddVoucher,
  defaultCreate
}) => {
  const initialForm: SettingFormData =
    setting === null
      ? {
          activationPcTitle: "",
          activationPcContent: "",
          activationPcSuccessedTitle: "",
          activationPcSuccessedContent: "",
          activationMbTitle: "",
          activationMbContent: "",
          activationMbSuccessedTitle: "",
          activationMbSuccessedContent: "",
          serialNumberPcContent: "",
          serialNumberMbContent: "",

          registerCouponPcBg: "",
          completeCouponPcBg: "",
          activationCouponPcBg: "",
          registerCouponMbBg: "",
          completeCouponMbBg: "",
          activationCouponMbBg: ""

          // registerCouponCode:  "",
          // completeCouponCode:  "",
          // activationCouponCode:  "",
        }
      : {
          activationPcTitle: maybe(() => setting.activationPcTitle, ""),
          activationPcContent: maybe(() => setting.activationPcContent, ""),
          activationPcSuccessedTitle: maybe(
            () => setting.activationPcSuccessedTitle,
            ""
          ),
          activationPcSuccessedContent: maybe(
            () => setting.activationPcSuccessedContent,
            ""
          ),
          activationMbTitle: maybe(() => setting.activationMbTitle, ""),
          activationMbContent: maybe(() => setting.activationMbContent, ""),
          activationMbSuccessedTitle: maybe(
            () => setting.activationMbSuccessedTitle,
            ""
          ),
          activationMbSuccessedContent: maybe(
            () => setting.activationMbSuccessedContent,
            ""
          ),
          serialNumberPcContent: maybe(() => setting.serialNumberPcContent, ""),
          serialNumberMbContent: maybe(() => setting.serialNumberMbContent, ""),

          registerCouponPcBg: maybe(() => setting.registerCouponPcBg, ""),
          completeCouponPcBg: maybe(() => setting.completeCouponPcBg, ""),
          activationCouponPcBg: maybe(() => setting.activationCouponPcBg, ""),
          registerCouponMbBg: maybe(() => setting.registerCouponMbBg, ""),
          completeCouponMbBg: maybe(() => setting.completeCouponMbBg, ""),
          activationCouponMbBg: maybe(() => setting.activationCouponMbBg, "")

          // registerCouponCode: maybe(() => setting.registerCouponCode, ""),
          // completeCouponCode: maybe(() => setting.completeCouponCode, ""),
          // activationCouponCode: maybe(() => setting.activationCouponCode, ""),
        };
  const intl = useIntl();

  const [pcdirty, setPcdirty] = useState(false);
  const [mbdirty, setMbdirty] = useState(false);

  const [pcsdirty, setPcsdirty] = useState(false);
  const [mbsdirty, setMbsdirty] = useState(false);

  const [pcfdirty, setPcfdirty] = useState(false);
  const [mbfdirty, setMbfdirty] = useState(false);

  return (
    <>
      <Form initial={initialForm} onSubmit={onSubmit}>
        {({ change, data, hasChanged, setNameValue, submit }) => (
          <Container>
            <AppHeader onBack={onBack}>
              {intl.formatMessage(sectionNames.configuration)}
            </AppHeader>
            <Grid>
              {setting ? (
                <>
                  <div>
                    <Card>
                      <CardTitle
                        title={intl.formatMessage({
                          defaultMessage: "Product Activation Setting"
                        })}
                      />
                      <CardContent>
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "The Benefits PC Title",
                            description: "activationPcTitle"
                          })}
                          name={"activationPcTitle"}
                          fullWidth
                          value={data.activationPcTitle}
                          onChange={change}
                        />
                        <FormSpacer />

                        <MultimediaEditor
                          initialValue={data.activationPcContent}
                          setDirty={setPcdirty}
                          dirty={pcdirty}
                          editorName={"The Benefits PC Content"}
                          editorHeight={150}
                          update={newtemplate => {
                            const data = {
                              target: {
                                name: "activationPcContent",
                                value: newtemplate
                              }
                            };
                            change(data);
                          }}
                        />
                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "The Benefits Mobile Title",
                            description: "activationMbTitle"
                          })}
                          name={"activationMbTitle"}
                          fullWidth
                          value={data.activationMbTitle}
                          onChange={change}
                        />
                        <FormSpacer />

                        <MultimediaEditor
                          initialValue={data.activationMbContent}
                          setDirty={setMbdirty}
                          dirty={mbdirty}
                          editorName={"The Benefits Mobile Content"}
                          editorHeight={150}
                          update={newtemplate => {
                            const data = {
                              target: {
                                name: "activationMbContent",
                                value: newtemplate
                              }
                            };
                            change(data);
                          }}
                        />

                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "The Benefits Successed PC Title",
                            description: "activationPcSuccessedTitle"
                          })}
                          name={"activationPcSuccessedTitle"}
                          fullWidth
                          value={data.activationPcSuccessedTitle}
                          onChange={change}
                        />
                        <FormSpacer />

                        <MultimediaEditor
                          initialValue={data.activationPcSuccessedContent}
                          setDirty={setPcsdirty}
                          dirty={pcsdirty}
                          editorName={"The Benefits Successed PC Content"}
                          editorHeight={150}
                          update={newtemplate => {
                            const data = {
                              target: {
                                name: "activationPcSuccessedContent",
                                value: newtemplate
                              }
                            };
                            change(data);
                          }}
                        />

                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage:
                              "The Benefits Successed Mobile Title",
                            description: "activationMbSuccessedTitle"
                          })}
                          name={"activationMbSuccessedTitle"}
                          fullWidth
                          value={data.activationMbSuccessedTitle}
                          onChange={change}
                        />
                        <FormSpacer />

                        <MultimediaEditor
                          initialValue={data.activationMbSuccessedContent}
                          setDirty={setMbsdirty}
                          dirty={mbsdirty}
                          editorName={"The Benefits Successed Mobile Content"}
                          editorHeight={150}
                          update={newtemplate => {
                            const data = {
                              target: {
                                name: "activationMbSuccessedContent",
                                value: newtemplate
                              }
                            };
                            change(data);
                          }}
                        />
                        <FormSpacer />

                        <MultimediaEditor
                          initialValue={data.serialNumberPcContent}
                          setDirty={setPcfdirty}
                          dirty={pcfdirty}
                          editorName={"How to Find SerialNumber PC"}
                          editorHeight={150}
                          update={newtemplate => {
                            const data = {
                              target: {
                                name: "serialNumberPcContent",
                                value: newtemplate
                              }
                            };
                            change(data);
                          }}
                        />
                        <FormSpacer />

                        <MultimediaEditor
                          initialValue={data.serialNumberMbContent}
                          setDirty={setMbfdirty}
                          dirty={mbfdirty}
                          editorName={"How to Find SerialNumber Mobile"}
                          editorHeight={150}
                          update={newtemplate => {
                            const data = {
                              target: {
                                name: "serialNumberMbContent",
                                value: newtemplate
                              }
                            };
                            change(data);
                          }}
                        />
                        <FormSpacer />

                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "register Coupon Pc Bg",
                            description: "registerCouponPcBg"
                          })}
                          name={"registerCouponPcBg"}
                          value={data.registerCouponPcBg}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />

                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "register Coupon Mobile Bg",
                            description: "registerCouponMbBg"
                          })}
                          name={"registerCouponMbBg"}
                          value={data.registerCouponMbBg}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />

                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Complete Info Coupon Pc Bg",
                            description: "completeCouponPcBg"
                          })}
                          name={"completeCouponPcBg"}
                          value={data.completeCouponPcBg}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Complete Info Coupon Mobile Bg",
                            description: "completeCouponMbBg"
                          })}
                          name={"completeCouponMbBg"}
                          value={data.completeCouponMbBg}
                          onChange={change}
                          setNameValue={setNameValue}
                        />

                        <FormSpacer />

                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Activation Successed Coupon Pc Bg",
                            description: "activationCouponPcBg"
                          })}
                          name={"activationCouponPcBg"}
                          value={data.activationCouponPcBg}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage:
                              "Activation Successed Coupon Mobile Bg",
                            description: "activationCouponMbBg"
                          })}
                          name={"activationCouponMbBg"}
                          value={data.activationCouponMbBg}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                      </CardContent>
                    </Card>
                    <CardSpacer />
                    <Card>
                      <CardTitle
                        title={intl.formatMessage({
                          defaultMessage: "User Register Voucher",
                          description: "Register Voucher"
                        })}
                        toolbar={
                          <Button
                            color={"primary"}
                            onClick={onAddVoucher("register")}
                            style={{ float: "right" }}
                          >
                            <FormattedMessage
                              defaultMessage="Assign Voucher"
                              description="button"
                            />
                          </Button>
                        }
                      />
                      <CardContent>
                        <ResponsiveTable>
                          <TableHead>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Name"
                                description="voucher name"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Code"
                                description="voucher code"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Min Order Subtotal"
                                description="voucher minSpent"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Discount"
                                description="voucher Discount"
                              />
                            </TableCell>
                          </TableHead>
                          <TableBody>
                            <TableCell>
                              {setting?.registerCoupon?.name}
                            </TableCell>
                            <TableCell>
                              {setting?.registerCoupon?.code}
                            </TableCell>
                            <TableCell>
                              {setting?.registerCoupon?.minSpent?.amount}{" "}
                              {setting?.registerCoupon?.minSpent?.currency}
                            </TableCell>
                            <TableCell>
                              {setting?.registerCoupon?.discountValue}{" "}
                              {setting?.registerCoupon?.discountValueType ==
                              "FIXED"
                                ? setting?.registerCoupon?.minSpent?.currency
                                : setting?.registerCoupon
                                ? "%"
                                : ""}
                            </TableCell>
                          </TableBody>
                        </ResponsiveTable>
                      </CardContent>
                    </Card>
                    <CardSpacer />
                    <Card>
                      <CardTitle
                        title={intl.formatMessage({
                          defaultMessage: "User Complete Info Voucher",
                          description: "Complete Voucher"
                        })}
                        toolbar={
                          <Button
                            color={"primary"}
                            onClick={onAddVoucher("complete")}
                            style={{ float: "right" }}
                          >
                            <FormattedMessage
                              defaultMessage="Assign Voucher"
                              description="button"
                            />
                          </Button>
                        }
                      />
                      <CardContent>
                        <ResponsiveTable>
                          <TableHead>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Name"
                                description="voucher name"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Code"
                                description="voucher code"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Min Order Subtotal"
                                description="voucher minSpent"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Discount"
                                description="voucher Discount"
                              />
                            </TableCell>
                          </TableHead>
                          <TableBody>
                            <TableCell>
                              {setting?.completeCoupon?.name}
                            </TableCell>
                            <TableCell>
                              {setting?.completeCoupon?.code}
                            </TableCell>
                            <TableCell>
                              {setting?.completeCoupon?.minSpent?.amount}{" "}
                              {setting?.completeCoupon?.minSpent?.currency}
                            </TableCell>
                            <TableCell>
                              {setting?.completeCoupon?.discountValue}{" "}
                              {setting?.completeCoupon?.discountValueType ==
                              "FIXED"
                                ? setting?.completeCoupon?.minSpent?.currency
                                : setting?.completeCoupon
                                ? "%"
                                : ""}
                            </TableCell>
                          </TableBody>
                        </ResponsiveTable>
                      </CardContent>
                    </Card>
                    <CardSpacer />
                    <Card>
                      <CardTitle
                        title={intl.formatMessage({
                          defaultMessage: "Product Activation Voucher",
                          description: "Activation Voucher"
                        })}
                        toolbar={
                          <Button
                            color={"primary"}
                            onClick={onAddVoucher("activation")}
                            style={{ float: "right" }}
                          >
                            <FormattedMessage
                              defaultMessage="Assign Voucher"
                              description="button"
                            />
                          </Button>
                        }
                      />
                      <CardContent>
                        <ResponsiveTable>
                          <TableHead>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Name"
                                description="voucher name"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Code"
                                description="voucher code"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Min Order Subtotal"
                                description="voucher minSpent"
                              />
                            </TableCell>
                            <TableCell>
                              <FormattedMessage
                                defaultMessage="Discount"
                                description="voucher Discount"
                              />
                            </TableCell>
                          </TableHead>
                          <TableBody>
                            <TableCell>
                              {setting?.activationCoupon?.name}
                            </TableCell>
                            <TableCell>
                              {setting?.activationCoupon?.code}
                            </TableCell>
                            <TableCell>
                              {setting?.activationCoupon?.minSpent?.amount}{" "}
                              {setting?.activationCoupon?.minSpent?.currency}
                            </TableCell>
                            <TableCell>
                              {setting?.activationCoupon?.discountValue}{" "}
                              {setting?.activationCoupon?.discountValueType ==
                              "FIXED"
                                ? setting?.activationCoupon?.minSpent?.currency
                                : setting?.activationCoupon
                                ? "%"
                                : ""}
                            </TableCell>
                          </TableBody>
                        </ResponsiveTable>
                      </CardContent>
                    </Card>
                  </div>
                </>
              ) : (
                <Card>
                  <CardContent>
                    <Button
                      color="primary"
                      onClick={defaultCreate}
                      disabled={disabled}
                    >
                      <FormattedMessage
                        defaultMessage="Create Default"
                        description="button"
                      />
                    </Button>

                    <CardSpacer />
                    <p style={{ color: "#999", marginLeft: "20px" }}>
                      {
                        "New product activation setting window has not been set, please initialize first"
                      }
                    </p>
                  </CardContent>
                </Card>
              )}
            </Grid>
            <SaveButtonBar
              disabled={disabled || !hasChanged}
              state={saveButtonBarState}
              onCancel={onBack}
              onSave={submit}
            />
          </Container>
        )}
      </Form>
    </>
  );
};
export default ProductActivationSettingDetails;
